import { usePutMutation } from "@/api/swr/useMutation";
import { companyProfileEditSchema } from "@/schema/app/profile/companyProfileEdit";
import { z } from "zod";

type Config = Parameters<typeof usePutMutation<typeof companyProfileEditSchema, z.ZodUndefined>>[3];

export const useEditCompanyProfile = (config?: Config) => {
  return usePutMutation(
    companyProfileEditSchema,
    z.undefined(),
    `/app/company`,
    config,
  );
};
